import styled from 'styled-components'
import { IconButton } from '@mui/material'

export const Formulario = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const TitleLaudos = styled.h3`
    fontsize: 18px;
    padding: 20px;
    background-color: #ededed;
    width: 100%;
`

export const ContainerItemCadastro = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: minmax(56px, 1fr);
    align-items: center;
    background-color: #fbfbfb;
    padding: 20px;
    border: 1px solid #ededed;
    border-radius: 5px;
    gap: 25px;
    @media (max-width: 950px) {
        grid-template-columns: 1fr;
        gap: 20px;
    }
`

export const ContainerCampo = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`
export const ContainerValor = styled.div`
    display: flex;
    flex-direction: column;
`

export const ContainerWindow = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const ExportarButton = styled(IconButton)`
    width: 40px;
    height: 40px;
`
